import references from './references';
import toolbar from './toolbar';
import documentPanel from './documentpanel';
import favorites from './favorites';

const documents = {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    getters: {
    },
    modules: {
        references,
        toolbar,
        documentPanel,
        favorites
    }
}

export default documents;